import { StateCreator } from 'zustand'

import { OnboardingDataSlice } from '../type'

export const createOnboardingDataSlice: StateCreator<
  OnboardingDataSlice,
  [],
  [],
  OnboardingDataSlice
> = (set, get) => ({
  name: '',
  genderIdentity: '',
  ageRange: '',
  personalDevelopmentFocus: '',
  journalingFocus: '',
  journalingHourEvening: '',
  journalingHourMorning: '',
  pushEnabledEvening: false,
  pushEnabledMorning: false,
  step: 0,
  setName: (name) => set({ name }),
  setGenderIdentity: (genderIdentity) => set({ genderIdentity }),
  setAgeRange: (ageRange) => set({ ageRange }),
  setPersonalDevelopmentFocus: (personalDevelopmentFocus) =>
    set({ personalDevelopmentFocus }),
  setJournalingFocus: (journalingFocus) => set({ journalingFocus }),
  setJournalingHourEvening: (journalingHourEvening) =>
    set({ journalingHourEvening }),
  setJournalingHourMorning: (journalingHourMorning) =>
    set({ journalingHourMorning }),
  setPushEnabledEvening: (pushEnabledEvening) => set({ pushEnabledEvening }),
  setPushEnabledMorning: (pushEnabledMorning) => set({ pushEnabledMorning }),
  setStep: (step) => set({ step }),
  getAllValues: () => ({
    name: get().name,
    genderIdentity: get().genderIdentity,
    ageRange: get().ageRange,
    personalDevelopmentFocus: get().personalDevelopmentFocus,
    journalingFocus: get().journalingFocus,
    journalingHourEvening: get().journalingHourEvening,
    journalingHourMorning: get().journalingHourMorning,
    pushEnabledEvening: get().pushEnabledEvening,
    pushEnabledMorning: get().pushEnabledMorning,
  }),
})
